// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarCalculoNumerador,
  getCalculoNumeradorSelecionado,
  getCalculoNumerador,
} from "../../../../state";

type Props = {
  disabled: boolean,
};

export default function SelecaoCalculoNumerador({ disabled }: Props) {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"configuracaoRelatorio.numerador.calculo"}
        itensSelector={getCalculoNumerador}
        selectorItemSelecionado={getCalculoNumeradorSelecionado}
        onItemChange={selecionarCalculoNumerador}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
        disabled={disabled}
      />
    </div>
  );
}
